import * as React from "react";
import { httpRequest } from "../services/httpService";
import { routerPath } from "../config/constents";
export interface PropRoute {
    path: string;
    element?: React.ReactNode | null;
}
//User Login
export const getUserLogin = (formData: any) => {
    return httpRequest.post(routerPath.API.userLogin, formData);
}

export const serviceproviderLogin = (formData: any) => {
    return httpRequest.post(routerPath.API.serviceproviderLogin, formData);
}
// ForgetPassword

export const forgetPassword = (formData: any) => {

    httpRequest.get(routerPath.API.forgetPassword + '?email=' + formData?.email);

}
export const updatePassword = (formData: any) => {

    httpRequest.post(routerPath.API.updatePassword, formData);

}


//InputData - PreCase

export const insertPrecase = (fromData: any) => {
    return httpRequest.post(routerPath.API.config.insertPreCase, fromData);
}

export const insertinputprecasedatasCPV = (fromData: any) => {
    return httpRequest.post(routerPath.API.config.insertinputprecasedatasCPV, fromData);
}

export const getPreCaseGridSearch = (UserID: any, search: any, lCorporateId: any) => {
    return httpRequest.get(routerPath.API.config.getPreCaseGridSearch + "?UserID=" + UserID + "&searchString=" + search + "&lCorporateId=" + lCorporateId);
}
export const getPreCaseGridData = (UserID: any, pageNumber: any, pageSize: any, fromDate: any, toDate: any, lCorporateId: any, caseType: any) => {
    return httpRequest.get(routerPath.API.config.getPreCaseGridData + "?startDate=" + fromDate + "&endDate=" + toDate + "&UserID=" + UserID + "&lCorporateId=" + lCorporateId + "&caseType=" + caseType);
}
export const getPreCasetable = (UserID: any, pageNumber: any, pageSize: any, lCorporateId: any) => {
    return httpRequest.get(routerPath.API.config.getPreCaseTable + "?UserID=" + UserID
        + "&pageNumber=" + pageNumber + "&pageSize=" + pageSize + "&lCorporateId=" + lCorporateId);
}
export const updatePreCase = (fromData: any) => {
    return httpRequest.put(routerPath.API.config.updatePreCase, fromData);
}
export const searchPreCase = (fromData: any) => {
    return httpRequest.get(routerPath.API.config.searchPreCase + "?searchData=" + fromData.search);
}
export const downloadExcel = (p0: { fileName: string; sheet: string; tablePayload: { header: string[]; body: any[][]; }; }) => {
    return httpRequest.get(routerPath.API.config.excelDownload)
}
export const InsertDocument = (fromData: any) => {
    return httpRequest.post(routerPath.API.config.insertDocument, fromData);
}

export const editPreCase = (Id: any) => {
    return httpRequest.get(routerPath.API.config.editPreCase + "?Id=" + Id + "&lCorporateId=0")
}

export const verifierStatusUpdate = (fromData: any) => {
    return httpRequest.post(routerPath.API.config.verifierStatusUpdate, fromData);
}

export const getfieldstaffsignupdetails = (Id: any) => {
    return httpRequest.get(`${routerPath.API.config.getfieldstaffsignupdetails}?userID=${Id}`);
}
//InputData - Postcase

export const inserPostCase = (fromData: any) => {
    return httpRequest.post(routerPath.API.config.inserPostCase, fromData);
}
export const getAllPostCase = (UserID: any, lCorporateId: any) => {
    return httpRequest.get(routerPath.API.config.getAllPostCase + "?UserID=" + UserID + "&lCorporateId=" + lCorporateId);
}

export const getPreCaseTable = (
  userID: number,
  pageSize: number,
  pageNumber: number,
  lCorporateId: number
) => {
  return httpRequest.get(
    routerPath.API.config.getPreCaseTable +
      "?UserID=" + userID +
      "&pageSize=" + pageSize +
      "&pageNumber=" + pageNumber +
      "&lCorporateId=" + lCorporateId
  );
};

export const updatePostcase = (fromData: any) => {
    return httpRequest.put(routerPath.API.config.updatePostcase, fromData);
}

// DashBoard

export const getDashBoard = (formData: any, vCorporateDetailsId: any, sRole: any, bankIds: any) => {
    return httpRequest.post(routerPath.API.config.getDashBoard + '?lCorporateId=' + vCorporateDetailsId + "&sRole=" + sRole + "&bankIds=" + bankIds, formData);
}
export const getDashBoardonLoad = (formData: any) => {
    debugger;
    return httpRequest.post(routerPath.API.config.getDashBoard + '?Type=' + formData?.Id);
}

export const randomFunction = () => {
    return httpRequest
        .get(routerPath.API.config.getDashBoardOnload + "?Type=" + "precase")
}

// Verification master
export const getVerificationTypeMaster = () => {
    return httpRequest.get(routerPath.API.config.getVerificationTypeMaster);
}

// Sampler API's

export const getDashboardData = (formData: any) => {
    return httpRequest.get(routerPath.API.config.getDashboardData + `?userID=${formData?.id}&startDate=${formData?.startDate}&endDate=${formData?.endDate}`);
}

export const getSamplerData = (id: any) => {
    return httpRequest.get(routerPath.API.config.getSamplerData + `?userID=` + id);
}

export const getSamplerDocType = () => {
    return httpRequest.get(routerPath.API.config.getSamplerDocType);
}

export const getProductForDropdown = (lCorporateId: any) => {
    return httpRequest.get(routerPath.API.config.getProductForDropdown + "?lCorporateId=" + lCorporateId);
}

export const insertSamplerData = (formData: any) => {
    return httpRequest.post(routerPath.API.config.insertSamplerData, formData);
}

export const getPreEmploymentGridData = (Id: any) => {
    return httpRequest.get(routerPath.API.config.getEmploymentDetails + "?employmentId=" + Id);
}


export const GetDocumentTypes = () => {
    return httpRequest.get(routerPath.API.config.GetDocumentTypes);
}

// export const getallDocumentDetails = (lCorporateId : any) => {
//     return httpRequest.get(routerPath.API.config.getallDocumentDetails + "?lCorporateId=" + lCorporateId);
// }

//New PreEmployment

export const GetEmploymentHeaderDetails = (employmentId: any) => {
    return httpRequest.get(routerPath.API.config.GetEmploymentHeaderDetails + "?employmentId=" + employmentId);
}

export const UpdateEmployementProfile = (formData: any) => {
    return httpRequest.put(routerPath.API.config.UpdateEmployementProfile, formData);
}

export const UpdateEmployementAddress = (formData: any) => {
    return httpRequest.put(routerPath.API.config.UpdateEmployementAddress, formData);
}

export const UpdateEmploymentCandidateConsent = (formData: any) => {
    return httpRequest.put(routerPath.API.config.UpdateEmploymentCandidateConsent, formData);
}

export const UpdateEmploymentKyc = (formData: any) => {
    return httpRequest.put(routerPath.API.config.UpdateEmploymentKyc, formData);
}
export const GetAllCountry = () => {
    return httpRequest.get(routerPath.API.config.GetAllCountry);
}
export const GetStateListByCountry = (id: number) => {
    return httpRequest.get(routerPath.API.config.GetStateListByCountry + `?CountryId=${id}`);
}
export const GetDistrictListByState = (id: number) => {
    return httpRequest.get(routerPath.API.config.GetDistrictListByState + `?StateId=${id}`);
}
export const DeleteEmploymentAddress = (id: number) => {
    return httpRequest.get(routerPath.API.config.DeleteEmploymentAddress + `?employmentAddressId=${id}`);
}
export const DeleteEmploymentGridDetails = (id: number) => {
    return httpRequest.get(routerPath.API.config.DeleteEmploymentGridDetails + `?employmentEmployerId=${id}`);
}
export const SendConsentMail = (formData: any) => {
    return httpRequest.post(routerPath.API.config.SendConsentMail, formData);
}


export const InsertorUpdateEmployementEmployerDetails = (formData: any) => {
    return httpRequest.post(routerPath.API.config.InsertorUpdateEmployementEmployerDetails, formData);
}

export const InsertorUpdateEmployementEducationDetails = (formData: any) => {
    return httpRequest.post(routerPath.API.config.InsertorUpdateEmployementEducationDetails, formData);
}

export const InsertorUpdateVendorAuthority = (formData: any) => {
    return httpRequest.post(routerPath.API.config.InsertorUpdateVendorAuthority, formData);
}

export const EditorGridBindVendorAuthority = (vendorAuthorityId: any) => {
    return httpRequest.get(
        routerPath.API.config.EditorGridBindVendorAuthority + "?vendorAuthorityId=" + vendorAuthorityId
    );
};

export const getcountrylists = () => {
    return httpRequest.get(routerPath.API.config.getcountrylists);
}

export const GetAllMasterEmploymentEducation = (CorporateId: any) => {
    return httpRequest.get(routerPath.API.config.GetAllMasterEmploymentEducation + "?CorporateId=" + CorporateId);
}

export const sendKycMail = (type: any, employmentId: any, corporateId: any) => {
    return httpRequest.get(routerPath.API.config.sendKycMail + "?type=" + type + "&employmentId=" + employmentId + "&corporateId=" + corporateId);
}

export const sendInputValidationMail = (formData: any) => {
    return httpRequest.post(routerPath.API.config.sendInputValidationMail, formData);
}

export const GetBotrayGridDetails = () => {
    return httpRequest.get(routerPath.API.config.GetBotrayGridDetails);
}

export const GetAllBOEmploymentDetails = (employmentId: any) => {
    return httpRequest.get(routerPath.API.config.GetAllBOEmploymentDetails + "?employmentId=" + employmentId);
}

export const InsertorUpdateBackofficeEmploymentConsent = (formData: any) => {
    return httpRequest.post(routerPath.API.config.InsertorUpdateBackofficeEmploymentConsent, formData);
}

export const InsertorUpdateBackofficeEmploymentEducation = (formData: any) => {
    return httpRequest.post(routerPath.API.config.InsertorUpdateBackofficeEmploymentEducation, formData);
}

export const InsertorUpdateBackofficeEmploymentEmployer = (formData: any) => {
    return httpRequest.post(routerPath.API.config.InsertorUpdateBackofficeEmploymentEmployer, formData);
}

export const InsertorUpdateBackofficeEmploymentKyc = (formData: any) => {
    return httpRequest.post(routerPath.API.config.InsertorUpdateBackofficeEmploymentKyc, formData);
}


export const GetQCtrayGridDetails = () => {
    return httpRequest.get(routerPath.API.config.GetQCtrayGridDetails);
}

export const GetMIStrayGridDetails = () => {
    return httpRequest.get(routerPath.API.config.GetMIStrayGridDetails);
}

export const InsertorUpdateQcEmploymentConsent = (formData: any) => {
    return httpRequest.post(routerPath.API.config.InsertorUpdateQcEmploymentConsent, formData);
}

export const InsertorUpdateQcEmploymentEducation = (formData: any) => {
    return httpRequest.post(routerPath.API.config.InsertorUpdateQcEmploymentEducation, formData);
}

export const InsertorUpdateQcEmploymentEmployer = (formData: any) => {
    return httpRequest.post(routerPath.API.config.InsertorUpdateQcEmploymentEmployer, formData);
}

export const InsertorUpdateQcEmploymentKyc = (formData: any) => {
    return httpRequest.post(routerPath.API.config.InsertorUpdateQcEmploymentKyc, formData);
}

export const InsertorUpdateEmployementPoliceDetails = (formData: any) => {
    return httpRequest.post(routerPath.API.config.InsertorUpdateEmployementPoliceDetails, formData);
}



